import React from 'react';
import { Link } from 'react-router-dom';
import { all_routes } from '../feature-module/router/all_routes';

interface NoAccountConnectedProps {
  title?: string;
  message?: string;
  to?: string;
  buttonText?: string;
  icon?: string;
}

const NoAccountConnected: React.FC<NoAccountConnectedProps> = ({
  title = "No Email Account Connected",
  message = "To start managing your emails, you need to connect at least one email account.",
  to = all_routes.emailSettings,
  buttonText = "Connect Email Account",
  icon = "ti ti-mail-off"
}) => {
  return (
    <div className="no-account-connected d-flex flex-column align-items-center justify-content-center py-5">
      <div className="text-center mb-4">
        <div className="empty-state-icon mb-4">
          <div className="avatar avatar-xxl text-primary mx-auto rounded-circle d-flex align-items-center justify-content-center">
            <i className={icon} style={{ fontSize: '48px', color: '#ffffffff' }}></i>
          </div>
        </div>

        <h4 className="fw-semibold mb-3 text-dark">{title}</h4>
        <p className="text-muted mb-4 max-w-md mx-auto" style={{ lineHeight: '1.6', fontSize: '16px' }}>
          {message}
        </p>

        <div className="empty-state-actions mb-4">
          <Link
            to={to}
            className="btn btn-primary btn-lg px-4 py-3"
          >
            <i className="ti ti-plug-connected me-2"></i>
            {buttonText}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NoAccountConnected; 